import { createFileRoute } from "@tanstack/react-router";
import { Landing } from "./index";

export const Route = createFileRoute("/security")({
  head: () => ({
    meta: [
      { title: "Security & Payment Protection — Lumvio" },
      {
        name: "description",
        content:
          "How Lumvio keeps freelancers and clients safe: identity verification (KYC), Payment Protection on milestones, device hard-lock and an encrypted client workspace.",
      },
      {
        name: "keywords",
        content:
          "freelance payment protection, secure freelance payments, identity verification KYC, encrypted client workspace, device protection, safe freelance platform",
      },
      { property: "og:title", content: "Security & Payment Protection — Lumvio" },
      { property: "og:description", content: "Identity-verified accounts, Payment Protection on every milestone, and an encrypted client workspace." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://lumvio.co/security" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Security & Payment Protection — Lumvio" },
      { name: "twitter:description", content: "Identity-verified accounts, Payment Protection on every milestone, and an encrypted client workspace." },
    ],
    links: [{ rel: "canonical", href: "https://lumvio.co/security" }],
  }),
  component: SecurityPage,
});

function SecurityPage() {
  return <Landing scrollTo="security" />;
}
